'use strict';

const GlobalContextBaseView = require('../../global/reactHelpers/GlobalContextBaseView');
const galleryActions = require('../actions/galleryActions');

const { classes, switchActions } = require('../helpers/GalleryConstants');
const contains = require('lodash.contains');

const GalleryArrowBox = GlobalContextBaseView.extend({
    el: `.${classes.ARROW_BOX}`,

    events: {
        click: 'onClickArrow',
    },

    constructor({ pageType, isModal } = {}) {
        this.pageType = pageType;
        this.isModal = isModal;

        GlobalContextBaseView.prototype.constructor.apply(this, arguments);
    },

    /**
     * Event handler for when user clicks on an arrow
     */
    onClickArrow(e) {
        const { action } = e.currentTarget.dataset;
        const pageType = this.pageType;

        if (contains(switchActions, action)) {
            this.context.executeAction(galleryActions.switchPhoto, { action, pageType });
            e.preventDefault();
        }
    },
});

module.exports = GalleryArrowBox;



// WEBPACK FOOTER //
// ./assets/js/gallery/views/GalleryArrowBox.es.js